import React, { ChangeEvent, useEffect, useState } from 'react'
import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CForm,
  CFormCheck,
  CFormInput,
  CFormSelect,
  CRow,
} from '@coreui/react-pro'
import { languages } from '../../../../../libs/languages'
import { useStore } from 'effector-react'
import {
  $offersByLang,
  $socialMediaGroup,
  offersByLangMounted,
  setSocialMediaGroupForm,
  submitCreateSocialMediaGroup,
} from './model'

export const CreateSocialMediaGroup: React.FC = () => {
  const [validated, setValidated] = useState(false)

  const socialMediaGroup = useStore($socialMediaGroup)
  const offersByLang = useStore($offersByLang)

  const handleChange = (
    event: ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    let value

    if (event.currentTarget.type === 'checkbox') {
      value = (event.currentTarget as HTMLInputElement).checked
    } else {
      value = event.currentTarget.value
    }

    setSocialMediaGroupForm({
      ...socialMediaGroup,
      [event.currentTarget.name]: value,
    })
  }

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const form = event.currentTarget

    if (!form.checkValidity()) {
      event.preventDefault()
      event.stopPropagation()
    } else {
      submitCreateSocialMediaGroup({
        ...socialMediaGroup,
        offerId: Number(socialMediaGroup.offerId),
      })
      event.preventDefault()
      event.stopPropagation()
    }
    setValidated(true)
  }

  useEffect(() => {
    offersByLangMounted({ lang: socialMediaGroup.lang })
  }, [socialMediaGroup.lang])

  useEffect(() => {
    if (offersByLang.length) {
      setSocialMediaGroupForm({
        ...socialMediaGroup,
        offerId: offersByLang[0].id,
      })
    }
  }, [offersByLang])

  return (
    <CCard className="mb-4">
      <CCardHeader className="d-sm-flex justify-content-between align-items-center">
        <strong>Create social media group</strong>
      </CCardHeader>
      <CCardBody>
        <CForm noValidate validated={validated} onSubmit={handleSubmit}>
          <CRow className="mb-3">
            <CCol sm={4}>
              <CFormInput
                type="text"
                name="title"
                value={socialMediaGroup.title}
                onChange={handleChange}
                label="Name"
                minLength={3}
                maxLength={30}
                required
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol sm={4}>
              <CFormSelect
                label="Language"
                name="lang"
                value={socialMediaGroup.lang}
                onChange={handleChange}
              >
                {languages.map((language) => (
                  <option value={language.value}>{language.label}</option>
                ))}
              </CFormSelect>
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol sm={4}>
              <CFormSelect
                label="Offer"
                name="offerId"
                value={socialMediaGroup.offerId}
                disabled={offersByLang.length === 0}
                onChange={handleChange}
              >
                {offersByLang?.map((offer) => (
                  <option value={offer.id}>{offer.title}</option>
                ))}
              </CFormSelect>
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol sm={4}>
              <CFormCheck
                name="isVisible"
                checked={socialMediaGroup.isVisible}
                onChange={handleChange}
                label="Active"
              />
            </CCol>
          </CRow>
          <CButton className="mb-3" type="submit">
            Save
          </CButton>
        </CForm>
      </CCardBody>
    </CCard>
  )
}
